import Stack from '@totallymoney/ui/components/Stack'
import Text from '@totallymoney/ui/components/Text'

const renderAccordionParagraphs = (
    paragraphs: string[]
): React.ReactElement => (
    <Stack space="space20">
        {paragraphs.map((paragraph, i) => (
            <Text color="light" variant="100" key={`${paragraph}-${i}`}>
                {paragraph}
            </Text>
        ))}
    </Stack>
)

export default renderAccordionParagraphs
